// Robotic-arm geometry shared by the 3D scene and the lab controller (no three.js needed).
export const ARM = { baseH: 0.35, l1: 0.9, l2: 0.8, grab: 0.22, basketR: 0.3, reach: 1.2 };
const rad = (d) => (d * Math.PI) / 180;
export const at = (yawDeg, r, y) => ({ x: r * Math.sin(rad(yawDeg)), y, z: -r * Math.cos(rad(yawDeg)) });
export const BLOCK_HOME = at(-50, ARM.reach, 0.09);
export const BASKET = at(50, ARM.reach, 0);
export const STACK_BLOCKS = [at(-50, 1.2, 0.09), at(-15, 1.35, 0.09), at(-80, 1.05, 0.09)]; // mission: 3 blocks
export const ARM_START = { yaw: 0, shoulder: 20, elbow: 30 };
export const LIMITS = { yaw: [-90, 90], shoulder: [0, 110], elbow: [0, 150] };

// Elbow and gripper tip: yaw turns the base, shoulder/elbow tilt forward from vertical (degrees).
export const armPoints = ({ yaw, shoulder, elbow }) => {
  const a = rad(shoulder), b = rad(shoulder + elbow);
  const re = ARM.l1 * Math.sin(a), ye = ARM.baseH + ARM.l1 * Math.cos(a);
  return { elbow: at(yaw, re, ye), tip: at(yaw, re + ARM.l2 * Math.sin(b), ye + ARM.l2 * Math.cos(b)) };
};
export const armTip = (pose) => armPoints(pose).tip;
export const dist = (p, q) => Math.hypot(p.x - q.x, p.y - q.y, p.z - q.z);
export const overBasket = (p) => Math.hypot(p.x - BASKET.x, p.z - BASKET.z) < ARM.basketR && p.y < 1.2;
export const nearest = (tip, blocks, skip = []) => {
  let best = -1, d = ARM.grab;
  blocks.forEach((b, i) => { const x = dist(tip, b); if (!skip.includes(i) && x < d) { d = x; best = i; } });
  return best;
};
